import http from '@/0/Libs/HttpHelper.js'
import store from '@/0/Libs/StoreHelper.js'

export default {

    async getByOpenId(openId,Url) {
        var url = Url+"?openId="+openId
        let { data : result } = await http.get(url);
        if (result.state == 1) {
            return result;
        }
        return result;
    },

    //【入库 页面初始加载-加载是缓存信息】
    async asyncShopStockInOrderStartScan() {
        console.log("start ======ShopStockInOrder======");
        var url = "mSmsApi/ShopStockInOrder/StartScan"
        let { data } = await http.post(url);
        console.log("end======ShopStockInOrder========>", data);
        if (data.state == 1) {
            return data.data;
        }
        return null;
    },
    //【入库 扫码验证】
    async asyncShopStockInOrderScanCode(code) {
        console.log("start ======ShopStockInOrderScanCode======");
        var url = "mSmsApi/ShopStockInOrder/ScanCode"
        let { data } = await http.post(url, { code: code });
        console.log("end======ShopStockInOrderScanCode========>", data);
        return data;
    },
    //【入库 删除已扫的码】
    async asyncShopStockInOrderDeleteScanCode(code) {
        console.log("start ======ShopStockInOrderDeleteScanCode======");
        var url = "mSmsApi/ShopStockInOrder/DeleteScanCode"
        let { data } = await http.post(url, { code: code });
        console.log("end======ShopStockInOrderDeleteScanCode========>", data);
        if (data.state == 1) {
            return data;
        }
        return null;
    },
    //【入库 提交已扫的码】
    async asyncShopStockInOrderSubmit() {
        console.log("start ======ShopStockInOrderSubmit======");
        var url = "mSmsApi/ShopStockInOrder/Submit"
        let { data } = await http.post(url);
        console.log("end======ShopStockInOrderSubmit========>", data);
        if (data.state == 1) {
            return data;
        }
        return null;
    },
    //获取入库列表
    async asyncGetShopStockInOrder(PageIndex,PageSize) {
        console.log("start ======GetOrderList======");
        var url = "mSmsApi/ShopStockInOrder/GetOrderList"
        let { data } = await http.post(url,{PageIndex:PageIndex,PageSize:PageSize});
        console.log("end======GetOrderList========>", data);
        if (data.state == 1) {
            return data.data;
        }
        return null;
    },
    //获取出库列表
    async asyncGetShopStockOutOrder(PageIndex,PageSize) {
        console.log("start ======GetOrderList======");
        var url = "mSmsApi/ShopStockOutOrder/GetOrderList"
        let { data } = await http.post(url,{PageIndex:PageIndex,PageSize:PageSize});
        console.log("end======GetOrderList========>", data);
        if (data.state == 1) {
            return data.data;
        }
        return null;
    },
    //获取盘库列表
    async asyncGetShopStockCheckOrder(PageIndex,PageSize) {
        console.log("start ======GetOrderList======");
        var url = "mSmsApi/ShopStockCheckOrder/GetOrderList"
        let { data } = await http.post(url,{PageIndex:PageIndex,PageSize:PageSize});
        console.log("end======GetOrderList========>", data);
        if (data.state == 1) {
            return data.data;
        }
        return null;
    },
    //【入库详情】【Get】
    async asyncGetShopStockInOrderDetail(openId) {
        console.log("start ======GetOrderInfo======");
        var url = "mSmsApi/ShopStockInOrder/GetOrderInfo?openId="+openId
        let { data } = await http.get(url);
        console.log("end======GetOrderInfo========>", data);
        if (data.state == 1) {
            return data.data;
        }
        return null;
    },
    //【出库详情】【Get】
    async asyncGetShopStockOutOrderDetail(openId) {
        console.log("start ======GetOrderInfo======");
        var url = "mSmsApi/ShopStockOutOrder/GetOrderInfo?openId="+openId
        let { data } = await http.get(url);
        console.log("end======GetOrderInfo========>", data);
        if (data.state == 1) {
            return data.data;
        }
        return null;
    },
    //【盘库详情】【Get】
    async asyncGetShopStockCheckOrderDetail(openId) {
        console.log("start ======GetOrderInfo======");
        var url = "mSmsApi/ShopStockCheckOrder/GetOrderInfo?openId="+openId
        let { data } = await http.get(url);
        console.log("end======GetOrderInfo========>", data);
        if (data.state == 1) {
            return data.data;
        }
        return null;
    },
    //获取列表页
    async asyncGetList(PageIndex,PageSize,Url) {
        var url = Url
        let { data } = await http.post(url,{PageIndex:PageIndex,PageSize:PageSize});
        if (data.state == 1) {
            return data;
        }
        return null;
    },
    //初始化
    async asyncGetInitForm(PageIndex,PageSize,Url) {
        var url = Url
        let { data } = await http.post(url,{PageIndex:PageIndex,PageSize:PageSize});
        if (data.state == 1) {
            return data;
        }
        return null;
    },
    //初始化详情
    async asyncGetInitFormDetail(OpenId,Url) {
        var url = Url
        let { data } = await http.post(url,{OpenId:OpenId});
        if (data.state == 1) {
            return data;
        }
        return null;
    },

    //发送验证码
    async SendIphoneCode(postData) {
        var url = sessionStorage.getItem('Url')
        let { data } = await http.post(url,postData);
        if (data.state == 1) {
            return data;
        }
        if (data.state == 0) {
            return data;
        }
        return null;
    },

    //查询
    async SearchInformation(postData) {
        var url = sessionStorage.getItem('QueryUrl')
        let { data } = await http.post(url,postData);
        if (data.state == 1) {
            return data;
        }
        return null
    },
}


